import React from "react";
const AuthenticationServiceContext = React.createContext({
    isLoading: false,
    process:null,
    postToken:null,
    pid:null,
    components:null,
    token:null,
    handleUpdateStep:()=>{},
    handlePid:()=>{},
    handleInquiryProcess:()=>{},
    handleLoading:()=>{},
    handleProcess:()=>{},
    handleError:()=>{},
    handleComponents:()=>{},
    handleGetProcess:()=>{},
    handleCreateProcess:()=>{},
    handleSkip:()=>{},
    handleReset:()=>{},
    handleRedirectToDivar:()=>{},

});
export default AuthenticationServiceContext;